import { render, staticRenderFns } from "./Index-ventas.vue?vue&type=template&id=03fd632f&scoped=true"
import script from "./Index-ventas.vue?vue&type=script&lang=js"
export * from "./Index-ventas.vue?vue&type=script&lang=js"
import style0 from "./Index-ventas.vue?vue&type=style&index=0&id=03fd632f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd632f",
  null
  
)

export default component.exports